
// import React from 'react';
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Auth from './components/Auth/Auth';
// import Dashboard from './components/Dashboard/Dashboard';
// import MedicalReports from './modules/MedicalReports';
// import WorkFromHome from './modules/WorkFromHome';
// import ForgotPassword from "./modules/ForgotPassword";

// function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Auth />} />

//         {/* <Route path="/dashboard/:role" element={<Dashboard />} /> */}

//         <Route path="/dashboard/:role/:module?" element={<Dashboard />} />
//        <Route path="/medical-reports" element={<MedicalReports />} />
//        <Route path="/work-from-home" element={<WorkFromHome />} />
//        <Route path="/forgot-password" element={<ForgotPassword />} />
//       </Routes>
//     </BrowserRouter>
//   );
// }


// export default App;











// import React from 'react';
// import { BrowserRouter, Routes, Route } from "react-router-dom";

// import Auth from './components/Auth/Auth';
// import Dashboard from './components/Dashboard/Dashboard';

// import MedicalReports from './modules/MedicalReports';
// import WorkFromHome from './modules/WorkFromHome';
// import ForgotPassword from "./modules/ForgotPassword";

// /* WEBSITE */
// import LandingPage from './components/Website/LandingPage';
// import FeaturesPage from './components/Website/FeaturesPage';
// import PricingPage from './components/Website/PricingPage';
// import AboutPage from './components/Website/AboutPage';
// import ContactPage from './components/Website/ContactPage';
// import DashboardShowcase from './components/Website/sections/DashboardShowcase';


// function App() {
//   return (
//     <BrowserRouter>

//       <Routes>

//         {/* WEBSITE */}
//         <Route path="/" element={<LandingPage />} />
//         <Route path="/features" element={<FeaturesPage />} />
//          <Route path="/dashboardshowcase" element={<DashboardShowcase/>} />
//         <Route path="/pricing" element={<PricingPage />} />
//         <Route path="/about" element={<AboutPage />} />
//         <Route path="/contact" element={<ContactPage />} />

//         {/* AUTH */}
//         <Route path="/login" element={<Auth />} />

//         {/* DASHBOARD */}
//         <Route path="/dashboard/:role/:module?" element={<Dashboard />} />

//         {/* MODULES */}
//         <Route path="/medical-reports" element={<MedicalReports />} />
//         <Route path="/work-from-home" element={<WorkFromHome />} />
//         <Route path="/forgot-password" element={<ForgotPassword />} />

//       </Routes>

//     </BrowserRouter>
//   );
// }

// export default App;













// import React from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";

// import Auth from "./components/Auth/Auth";
// import Dashboard from "./components/Dashboard/Dashboard";

// import MedicalReports from "./modules/MedicalReports";
// import WorkFromHome from "./modules/WorkFromHome";
// import ForgotPassword from "./modules/ForgotPassword";
// import LeaveReport from "./modules/LeaveReport";


// /* WEBSITE */
// import LandingPage from "./components/Website/LandingPage";
// import FeaturesPage from "./components/Website/FeaturesPage";
// import PricingPage from "./components/Website/PricingPage";
// import AboutPage from "./components/Website/AboutPage";
// import ContactPage from "./components/Website/ContactPage";
// import DashboardShowcase from "./components/Website/sections/DashboardShowcase";
// import PlanCheckout from "./components/Website/sections/PlanCheckout";
// import HelpCenter from "./components/Website/HelpCenter";
// import PrivacyPolicy from "./components/Website/PrivacyPolicy";
// import Terms from "./components/Website/Terms";
// import ProductsPage from "./components/Website/ProductsPage";
// import PaymentSuccess from "./components/Website/PaymentSuccess";
// import PaymentTerms from "./components/Website/PaymentTerms";


// function App() {
//   return (
//     <BrowserRouter>

//       <Routes>

//         {/* WEBSITE */}
//         <Route path="/" element={<LandingPage />} />
//         <Route path="/features" element={<FeaturesPage />} />
//         <Route
//           path="/dashboardshowcase"
//           element={<DashboardShowcase />}
//         />
//         <Route path="/pricing" element={<PricingPage />} />
//         <Route path="/plan-checkout" element={<PlanCheckout />} />
//         <Route path="/about" element={<AboutPage />} />
//         <Route path="/contact" element={<ContactPage />} />
//         <Route path="/help-center" element={<HelpCenter />} />
//         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
//         <Route path="/terms" element={<Terms />} />
//         <Route
//           path="/products"
//           element={<ProductsPage />}
//         />
//         <Route
//           path="/payment-success"
//           element={<PaymentSuccess />}
//         />

//         <Route
//           path="/payment-terms"
//           element={<PaymentTerms />}
//         />

//         {/* AUTH */}
//         <Route path="/login" element={<Auth />} />

//         {/* DASHBOARD */}
//         <Route
//           path="/dashboard/:role/:module?"
//           element={<Dashboard />}
//         />

//         {/* MODULES */}
//         <Route
//           path="/medical-reports"
//           element={<MedicalReports />}
//         />
//         <Route
//           path="/work-from-home"
//           element={<WorkFromHome />}
//         />
//         <Route
//           path="/forgot-password"
//           element={<ForgotPassword />}
//         />
//         <Route path="/leave-report" element={<LeaveReport />} />


//       </Routes>
//     </BrowserRouter>
//   );
// }

// export default App;





















import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Auth from "./components/Auth/Auth";
import Dashboard from "./components/Dashboard/Dashboard";

import MedicalReports from "./modules/MedicalReports";
import WorkFromHome from "./modules/WorkFromHome";
import ForgotPassword from "./modules/ForgotPassword";
import LeaveReport from "./modules/LeaveReport";


/* WEBSITE */
import HomePage from "./components/Website/HomePage";
import GTELINQ from "./components/Website/products/GTELINQ";
import HiringHub from "./components/Website/products/HiringHub";
import CRM from "./components/Website/products/CRM";
import Payroll from "./components/Website/products/Payroll";
import InventoryManagement from "./components/Website/products/InventoryManagement";
import PurchaseProcurement from "./components/Website/products/PurchaseProcurement";
import WarehouseManagement from "./components/Website/products/WarehouseManagement";
import LandingPage from "./components/Website/LandingPage";
import FeaturesPage from "./components/Website/FeaturesPage";
import PricingPage from "./components/Website/PricingPage";
import AboutPage from "./components/Website/AboutPage";
import ContactPage from "./components/Website/ContactPage";
import DashboardShowcase from "./components/Website/sections/DashboardShowcase";
import PlanCheckout from "./components/Website/sections/PlanCheckout";
import HelpCenter from "./components/Website/HelpCenter";
import PrivacyPolicy from "./components/Website/PrivacyPolicy";
import Terms from "./components/Website/Terms";
import ProductsPage from "./components/Website/ProductsPage";
import PaymentSuccess from "./components/Website/PaymentSuccess";
import PaymentTerms from "./components/Website/PaymentTerms";


function App() {
  return (
    <BrowserRouter>

      <Routes>

        {/* WEBSITE */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/products/gtelinq" element={<GTELINQ />} />
        <Route path="/products/hiring-hub" element={<HiringHub />} />
        <Route path="/products/crm" element={<CRM />} />
        <Route path="/products/payroll" element={<Payroll />} />
        <Route path="/products/inventory" element={<InventoryManagement />} />
        <Route path="/products/procurement" element={<PurchaseProcurement />} />
        <Route path="/products/warehouse" element={<WarehouseManagement />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route
          path="/dashboardshowcase"
          element={<DashboardShowcase />}
        />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/plan-checkout" element={<PlanCheckout />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route
          path="/products"
          element={<ProductsPage />}
        />
        <Route
          path="/payment-success"
          element={<PaymentSuccess />}
        />

        <Route
          path="/payment-terms"
          element={<PaymentTerms />}
        />

        {/* AUTH */}
        <Route path="/login" element={<Auth />} />

        {/* DASHBOARD */}
        <Route
          path="/dashboard/:role/:module?"
          element={<Dashboard />}
        />

        {/* MODULES */}
        <Route
          path="/medical-reports"
          element={<MedicalReports />}
        />
        <Route
          path="/work-from-home"
          element={<WorkFromHome />}
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route path="/leave-report" element={<LeaveReport />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;

